import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Broker } from '../models/broker.model';
import { UrlService } from './url.service';

@Injectable({
  providedIn: 'root'
})
export class BrokerService {

	private svcUrl = '/Brokers';

	constructor(private http: HttpClient, private url: UrlService) {

	}

	getBrokers(): Observable<Broker[]> {
		return this.http.get<Broker[]>(this.url.getBaseURL() + this.svcUrl);
	}

	getBroker(id: number): Observable<Broker> {
		return this.http.get<Broker>(this.url.getBaseURL() + this.svcUrl + '/' + id);
	}

	createBroker(item: Broker): Observable<Broker> {
		return this.http.post<Broker>(this.url.getBaseURL() + this.svcUrl, item);
	}


}
